<template>
  <PageTemplate>

    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between">
        <h6 class="element-header">
          {{ $t('travel_expenses.title') }}
        </h6>

        <CreateButton
            :label="$t('travel_expenses.create')"
            :to="{ name: 'travelExpensesDetails' }">
        </CreateButton>
      </div>

      <Search
          :filters="filters"
          :loading="isSearching"
          :monthsInYearDropdown="monthsDropdown"
          :yearsDropdown="yearsDropdown"
          :statuesDropdown="statusesDropdown"
          :usersDropdown="usersDropdown"
          :hideStatus="true"
          @search="getTravelExpensesList"/>

      <div class="element-box mt-0">
        <Menu/>

        <PerPage :values="[10, 25, 50, 100]" @update:perPage="getTravelExpensesList"/>

        <div class="table-responsive mt-3">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>
                {{ $t('general.employee') }}
              </th>
              <th class="text-end">
                {{ $t('general.year') }}
              </th>
              <th class="text-start" style="padding-left: 60px;">
                {{ $t('general.month') }}
              </th>
              <th class="text-end">
                {{ $t('general.kilometer') }}
              </th>
              <th class="text-end">
                {{ $t('general.price') }}
              </th>
              <th class="text-end">
                {{ $t('general.total') }}
              </th>
              <th class="text-center">
                {{ $t('general.status') }}
              </th>
              <th class="text-center">
              </th>
              <th class="text-center">
              </th>
              <th class="text-end">
                {{ $t('general.actions') }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="expense in travelExpenses.data" :key="expense.id">
              <td>
                {{ expense.user.firstName }} {{ expense.user.lastName }}
              </td>
              <td class="text-end">
                {{ expense.year }}
              </td>
              <td class="text-start" style="padding-left: 60px;">
                <strong class="js-lists-values-employee-name">
                  {{ $t(`calendar.months_number_key.${expense.month}`) }}
                </strong>
              </td>
              <td class="text-end">
                {{ expense.distance }}
              </td>
              <td class="text-end">
                {{ expense.price }}
              </td>
              <td class="text-end">
                {{ expense.total }} €
              </td>
              <td class="text-center">
                <span v-if="expense.status === 'draft'" class="status-pill yellow p-2 ms-1"
                      data-bs-toggle="tooltip"></span>
                <span v-if="expense.status === 'modification'" class="status-pill red p-2 ms-1"
                      data-bs-toggle="tooltip"></span>
                <span v-if="expense.status === 'pending'" class="status-pill yellow p-2 ms-1"
                      data-bs-toggle="tooltip"></span>
                <span v-if="expense.status === 'approved_by_coordinator'" class="status-pill p-2 ms-1"
                      style="background-color: mediumseagreen" data-bs-toggle="tooltip"></span>
                <span v-if="expense.status === 'approved'" class="status-pill green p-2 ms-1"
                      data-bs-toggle="tooltip"></span>
                <span class="ms-2">{{ expense.statusTranslated }}</span>
              </td>
              <td>
<!--                &lt;!&ndash; Waiting approval &ndash;&gt;-->
<!--                <template v-if="expense.status !== 'approved'">-->
<!--                  <template v-if="(isHr && expense.hrNotification) || (!isHr && expense.coordinatorNotification)">-->
<!--                    <i style="font-size: 26px; color: #43ad4e;" class="os-icon os-icon-alert-circle"></i>-->
<!--                    <span style="-->
<!--                              position:absolute;-->
<!--                              font-size: 8px;-->
<!--                              padding: 3px 8px;-->
<!--                              background-color: red;-->
<!--                              color: white;-->
<!--                              border-radius: 11px;">!</span>-->
<!--                  </template>-->
<!--                </template>-->
              </td>
              <td>
<!--                &lt;!&ndash; Unseen messages  &ndash;&gt;-->
<!--                <template v-if="(isHr && expense.hrUnseenCount > 0) || (!isHr && expense.coordinatorUnseenCount > 0)">-->
<!--                  <i style="font-size: 26px; color: #43ad4e;" class="os-icon os-icon-mail-07"></i>-->
<!--                  <span style="-->
<!--                            position:absolute;-->
<!--                            font-size: 8px;-->
<!--                            padding: 3px 8px;-->
<!--                            background-color: red;-->
<!--                            color: white;-->
<!--                            border-radius: 11px;">!</span>-->
<!--                </template>-->
              </td>
              <td class="text-end" style="max-width: 50px;">
                <button class="btn btn-primary"
                        @click="router.push({name: 'coordinatorTravelExpensesDetails', params: {id: expense?.id} })">
                  <i class="os-icon os-icon-edit"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <Pagination
            v-if="travelExpenses.pagination?.total_pages > 1"
            :totalPages="travelExpenses.pagination?.total_pages"
            :currentPage="travelExpenses.pagination?.current_page"
            @pagechanged="getTravelExpensesList"/>
      </div>
    </div>
  </PageTemplate>
</template>


<script setup>
import travelExpensesService from '@/api/TravelExpenses';
import CreateButton from '@/components/CreateButton.vue';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import {ErrorToast} from '@/components/VueToast';
import router from '@/router';
import {getTravelExpensesUsersForCoordinator, getYears} from '@/shared/dropdowns';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import Search from '@/views/App/TravelExpenses/Coordinator/List/Search.vue';
import {computed, onMounted, ref} from 'vue';
import Menu from "@/views/App/TravelExpenses/Coordinator/List/Menu.vue";

const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const travelExpenses = ref([]);
const pagination = ref(null);
const isSearching = ref(false);
const isLoaded = ref(false);
const yearsDropdown = ref([]);
const monthsDropdown = ref([]);
const statusesDropdown = ref([]);
const usersDropdown = ref([]);
const isHr = ref(false)

const filters = ref({
  userId: '',
  year: '',
  month: '',
  status: '',
});

async function getTravelExpensesList(page = 1, perPage, passedFilters) {
  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = travelExpenses.value?.pagination?.items_per_page;

  try {
    const {data} = await travelExpensesService.getApprovedListForCoordinator({
      page: page,
      limit: perPage ?? perPageRes,
      ...(passedFilters ? passedFilters : filters.value),
    });

    travelExpenses.value = data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

async function getEnumsDropdown() {
  statusesDropdown.value = getEnums?.value?.travelExpensesStatuses || [];
  monthsDropdown.value = getEnums?.value?.monthsInYear || [];
}

async function checkIsHr() {
  const {data} = await travelExpensesService.coordinatorIsHr();
  isHr.value = data.data
}

onMounted(async () => {
  await Promise.all([
    await getYears(yearsDropdown),
    await getTravelExpensesList(),
    await getEnumsDropdown(),
    await getTravelExpensesUsersForCoordinator(usersDropdown),
    await checkIsHr(),
  ]);

  isLoaded.value = true;
});


</script>

<style scoped>

</style>